import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useParams } from 'react-router'
import {
  useErrorService,
  useNotificationService,
  Button,
} from '@abroad/components'
import API from '../../utils/API'
const TerminatedModal = ({ showModal, handleClose, setInitialValues }) => {
  const Error = useErrorService()
  let { clientId, planId } = useParams()
  const Notification = useNotificationService()
  const [isLoaoding, setIsLoading] = useState(false)

  const handleTerminate = async () => {
    setIsLoading(true)
    try {
      const { data } = await API.AdminAPI.coachPlan.sowTerminateClient(
        clientId,
        planId,
      )
      if (data) {
        // Update the initial values with terminated status
        if (setInitialValues) {
          setInitialValues((prevValues) => ({
            ...prevValues,
            ...(data.sow || {}),
          }))
        }

        Notification.showNotification(
          'Subscription has been terminated successfully',
          'success',
        )
        setIsLoading(false)
        handleClose()
      }
    } catch (e) {
      Error.showError(e)
      setIsLoading(false)
    }
  }
  const modalClose = () => {
    handleClose()
  }

  return (
    <>
      <Modal
        show={showModal}
        onHide={handleClose}
        centered
        className='payment-modal'>
        <Modal.Header className='payment-modal-header d-flex justify-content-center'>
          <h3 className='payment-modal-title mb-0'>Terminate Subscription </h3>
        </Modal.Header>
        <Modal.Body className='payment-modal-body'>
          <>
            <h5>Are you sure that you want to terminate this subscription?</h5>
            <p className='pt-2'>This action cannot be undone.</p>
          </>
        </Modal.Body>
        <Modal.Footer className='border-0 d-flex justify-content-between justify-content-lg-end pt-0'>
          <Button
            variant='secondary-light'
            onClick={modalClose}
            className='px-3 secondary-popup-button'
            size='sm'>
            Cancel
          </Button>
          <Button
            variant='saffron'
            size='sm'
            disabled={isLoaoding}
            onClick={handleTerminate}
            className='text-uppercase border-radius-normal text-white hover:text-white'>
            {isLoaoding ? 'Loading..' : 'CONFIRM'}{' '}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default TerminatedModal
